// Types
import { CardGridContainerProps } from './types';
// Styles
import StyledCardGrid from './styles';

const CardGridContainer: React.FC<CardGridContainerProps> = ({
  minMaxVal,
  children,
  ...props
}) => {
  return (
    <StyledCardGrid $minMaxVal={minMaxVal} {...props}>
      {children}
    </StyledCardGrid>
  );
};

export default CardGridContainer;
